module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMzUuNjkgMTc2LjI2Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzlhOWE5YTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPjAxbl8xPC90aXRsZT48ZyBpZD0iQ2FwYV8yIiBkYXRhLW5hbWU9IkNhcGEgMiI+PGcgaWQ9IkxheWVyXzEiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzIuNTIsMS4zQTg3Ljc5LDg3Ljc5LDAsMCwxLDY4LjksNDguNDZhODguMTgsODguMTgsMCwwLDEtNTYuODEsMTExQTkxLjEzLDkxLjEzLDAsMCwxLDAsMTYyLjM0LDg4LjE0LDg4LjE0LDAsMSwwLDMyLjUyLDEuM1oiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather-icons/bgwhite/01n.svg
// module id = RrIy
// module chunks = 4